module.exports = __webpack_public_path__ + "alert.34bcb16e.mp3";


//////////////////
// WEBPACK FOOTER
// ../ui-components/components/OrderSoundPlayer/alert.mp3
// module id = 2497
// module chunks = 1